export enum ChangeDate {
  any,
  hours1,
  hours3,
  today,
  days3,
  week,
}
